<div class="flex w-full flex-col gap-5">
  <div class="mt-5 flex flex-col items-center self-center">
    @if (!loading()) {
      @if (twoFaImage(); as img) {
        <img [src]="img" alt="QR" class="mx-auto max-w-[177px]" />
      }
      @if (twoFaCode(); as code) {
        <div class="pt-2 text-center">
          <p>{{ 'setup-two-factor-auth-app.qr-description' | translate }}</p>
          <div payCopyable [textToCopy]="code" class="flex flex-row items-center gap-1">
            <span>
              {{ code }}
            </span>
            <pay-icon [shape]="IconNames.CopyFile" [size]="'xs'" />
          </div>
        </div>
      }
    } @else {
      <div class="min-h-inherit flex flex-grow items-center justify-center">
        <pay-spinner class="flex h-12 w-12" />
      </div>
    }
  </div>
  @if (qrError(); as err) {
    <pay-login-error-badge [error]="err" />
  } @else {
    <div>
      <span class="font-semibold">{{ 'setup-two-factor-auth-app.explain.header' | translate }}</span>
      <ul class="list-disc pl-5 pt-3">
        <li>{{ 'setup-two-factor-auth-app.explain.step-1' | translate }}</li>
        <li>{{ 'setup-two-factor-auth-app.explain.step-2' | translate }}</li>
        <li>{{ 'setup-two-factor-auth-app.explain.step-3' | translate }}</li>
      </ul>
    </div>
    <div class="pt-5">
      <span class="font-semibold">
        {{ 'setup-two-factor-auth-app.code.label' | translate }}
        <span class="text-negative-150">*</span>
      </span>
      <div class="py-3">
        <pay-lib-pin-entry (valueEntered)="submitPinEntry()" #pinEntryComponent [pinCount]="6" />
        <div class="my-2 text-sm text-neutral-80 sm:px-2">
          {{ 'setup-two-factor-auth-app.code.extra-text' | translate }}
        </div>
      </div>
    </div>
    <pay-button-primary [loading]="this.isSubmitting()" (click)="submitPinEntry()" [rounded]="'rounded-lg'">
      {{ 'setup-two-factor-auth-app.button-setup' | translate }}
    </pay-button-primary>
    @if (error(); as err) {
      <pay-login-error-badge [error]="err" />
    }
  }
</div>
